const modelName = "Account Types";
const modelNameSingular = "Account Type";
const endpoint = "/account-types";

const setup = {
  title: modelName,
  singular: modelNameSingular,
  model: modelName.replace(/\s+/g, "-").toLowerCase(),
  canDelete: true,
  canAddNew: true,
  canSearch: true,
  endpoint,
  accessor: "id",
};

export default setup;
